import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=39f51dba&scoped=true"
import script from "./Examination.vue?vue&type=script&lang=js"
export * from "./Examination.vue?vue&type=script&lang=js"
import style0 from "./Examination.vue?vue&type=style&index=0&id=39f51dba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f51dba",
  null
  
)

export default component.exports